import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { RootState } from '@store/store'
import { AudioType } from '@shared/enums'

export const audioUrl = 'audio/'

export interface AudioModel extends DjangoModel {
  length: string
  filepath: string
  name: string
  isDefault: boolean
  audioType: AudioType
}

const {
  slice: AudioSlice,
  thunks: AudioThunks,
  adapter: AudioAdapter,
  selectors,
} = createGenericSlice<AudioModel>('audio', audioUrl, {})

export const AudioAdapterExport = AudioAdapter

export const { selectById: selectAudioById, selectAll: selectAllAudios } =
  AudioAdapter.getSelectors<RootState>((state: RootState) => state.audio)

export const { fetchById: fetchAudioById, fetchAll: fetchAllAudios } =
  AudioThunks
export const {
  selectLoading: selectAudioLoading,
  selectIsIdInProgress: selectIsAudioIdInProgress,
} = selectors

export default AudioSlice.reducer
